// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../var/task/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".voucher-form[data-v-1c7177a2]{max-width:600px}", ""]);
// Exports
module.exports = exports;
